module.exports = __webpack_public_path__ + "static/media/headerCommandsMobile.71b3afea.svg";